import React, { useState, useRef } from "react";
import { Formik, Form } from "formik";
import swal from "sweetalert";
import moment from "moment";
import { usePost } from "seed/api";
import ExcelField from "components/util/helpers/ExcelField";
import l from "components/util/l";

import lazyCall from "components/util/helpers/LazyCall";
const exportExcelFile = lazyCall("exportExcelFile", "components/collections/util/excel");

const ImportForm = ({
  collections = {},
  activeCollection,
  primaryKey = null,
  columns = [],
  isSingleImport = false,
  onClickImport = () => { },
  onClose = () => { }
}) => {

  let filteredColumns = columns.filter((c) => !c.internal);
  if (primaryKey) {
    filteredColumns = filteredColumns.sort((a, b) => {
      if (a.name === primaryKey) return -1;
      if (b.name === primaryKey) return 1;
      return 0;
    });
  }

  const excelFileRef = useRef();
  const [hasDifferentColumns, setHasDifferentColumns] = useState(false);
  const [importedData, setImportedData] = useState(null);

  const [callGetExportData] = usePost("/collections/get_data", {
    onCompleted: (data) => {
      exportExcelFile({
        collections,
        columns,
        rows: data.data,
        fileName: `${data.collection.ui_settings.label}_${moment().format("YYYYMMDDHHmmss")}.xlsx`,
        primaryKey: primaryKey,
      });
    }
  });

  const [callValidateData, reqValidateData] = usePost("/collections/validate_data", {
    onCompleted: (data) => {

      if(hasDifferentColumns && data.logs.length == 0) {

        onClickImport(data);
        onClose();

      }
      else {

        setImportedData(data);

        if(data.logs.length > 0)
          excelFileRef.current.setStatus({
            type: "danger",
            message: l("Error al cargar el archivo%CA095"),
            logs: data.logs
          });
        else
          excelFileRef.current.setStatus({
            type: "success",
            message: l("Archivo cargado correctamente%CA096"),
            logs: data.logs
          });

      }

    }
  });

  const loadDataToValidate = async (data) => {

    if(!data) return;
    let { hasSameReferenceColumns, importedColumns, importedRows, rawRows } = data;

    if (rawRows.length > 0 && hasSameReferenceColumns) {
      setHasDifferentColumns(false);
      callValidateData({
        collection_id: activeCollection.id,
        primary_key: primaryKey,
        schema: filteredColumns,
        data: rawRows
      });
    }
    else {
      setHasDifferentColumns(true);
      setImportedData({
        importedColumns,
        importedRows,
        rawRows
      });
    }

  }

  const onClickDownloadTemplate = () =>
    callGetExportData({
      collection_id: activeCollection.id,
      ignore_compress: true,
    });

  const _onClickImport = () => {

    if(hasDifferentColumns) {

      swal({
        title: l("Actualizar columnas%CA099"),
        icon: "warning",
        text: l("Se encontraron columnas diferentes a las de la tabla. ¿Deseas actualizar las columnas de la tabla?%CA100"),
        buttons: {
          confirm: {
            text: l("Aceptar%GA020"),
            className: "swal-button swal-button--cancel btn-success",
          },
          cancel: l("Conservar columnas%CA157")
        },
      }).then((response) => {
        
        if (response) {
          callValidateData({
            collection_id: activeCollection.id,
            primary_key: importedData.importedColumns[0]?.name || null,
            data: importedData.importedRows,
            schema: importedData.importedColumns,
            columns: importedData.importedColumns,
            override_columns: true
          });
        }
        else {
          callValidateData({
            collection_id: activeCollection.id,
            primary_key: primaryKey,
            data: importedData.rawRows,
            schema: filteredColumns,
            override_columns: false
          });
        }

      });

    }
    else {

      onClickImport({
        collection_id: activeCollection.id,
        rows: importedData.rows,
        columns: importedData.columns,
        override_columns: false
      });

      onClose();

    }

  }

  const isLoading = reqValidateData.loading;

  return <div className="card">

    <div class="card-header">
      <h3 class="mb-0">
        {l("Cargar excel%CA101")}
      </h3>
    </div>
    <div class="card-body py-4 px-6">

      <Formik
        initialValues={{}}
        onSubmit={_onClickImport}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <ExcelField
              ref={excelFileRef}
              rowLimit={1000}
              referenceColumns={filteredColumns}
              ignoreColumns={!hasDifferentColumns}
              isSingleImport={isSingleImport}
              onLoadFile={loadDataToValidate}
              onDownloadTemplate={onClickDownloadTemplate}
            />

            <button
              type="submit"
              class={`btn btn-block mt-4 
                ${excelFileRef?.current?.status?.logs?.reduce((acc, log) => acc || log.type == "error", false)?.length > 0 
                  ? "btn-warning" : "btn-primary"}
              `}
              disabled={isLoading}
            >
              {
                isLoading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              }
              {
                !isLoading && <><i class="fa fa-upload mr-2"></i> {l("Importar%CA107")} </>
              }
            </button>

          </Form>

        }
      </Formik>

    </div>

  </div>;

}

export default ImportForm;